module.exports = __webpack_public_path__ + "img/Weizmann_Institute.2d701261.svg";